/*
 * @Author: Teemo Ding
 * @Date: 2021-07-09 16:18:22
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 15:56:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Taxes/TaxEditPage/TaxValidCountry/index.tsx
 */
// import { QuestionCircleFilled } from '@ant-design/icons';
// import WhiteBackgroundTooltip, {
//   TooltipContainer,
//   TooltipTitle,
//   TooltipContent,
// } from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
//import { Form } from 'antd';
import Table from '@/src/components/EditableTable/EditableTable';
// import { Form } from 'antd';
// import { RadioGroup, RadioItem } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
//import { Checkbox } from '@/src/components/Antd';
import { useStoreCountries } from '@/src/pages/Settings/Components/SelectCountryArea';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { countryColumns } from '../config';
import css from '../css.module.less';
import CountrySelect from './CountrySelect';

export enum TaxAreaType {
  Rest = 'Rest',
  Specific = 'Specific',
}

const TaxValidCountry = ({
  countryList = [],
  setCountryList,
  disabled,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { loading: getStoreCountriesLoading, list = [] } = useStoreCountries();

  const deleteCountry = (record) => {
    const countryFilterList = countryList.filter(
      (o) => o?.country?.code !== record?.country?.code,
    );
    setCountryList(countryFilterList);
  };

  const onConfirm = (data) => {
    setCountryList(data);
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      title={getI18n('storeTaxes.taxEditPage.taxValidCountryArea')}>
      <h3 className={css.taxCountryTitle}>
        {getI18n('storeTaxes.taxListPage.taxCountryArea')}
      </h3>
      {disabled ? null : (
        <Fragment>
          <CountrySelect
            value={countryList}
            onConfirm={onConfirm}
            list={list}
            getStoreCountriesLoading={getStoreCountriesLoading}
            disableEdit={disableEdit}
          />
          {(countryList || []).length ? (
            <Table
              id='countryList'
              rowKey={(record) => record?.country?.code}
              className={css.globalTable}
              columns={countryColumns(deleteCountry, list, disableEdit, {
                getI18n,
              })}
              dataSource={countryList}
            />
          ) : null}
          {/* <div className={css.chargeTax}>
          <Form.Item name='chargeTax' noStyle valuePropName='checked'>
            <Checkbox className={css.chargeTaxCheckbox}>
              Charge tax on shipping rates
            </Checkbox>
          </Form.Item>
          <div className={css.chargeTaxText}>
            If this rate also applies to shipping, check this box.
          </div>
        </div> */}
        </Fragment>
      )}
      {/* <SplitLine className={css.splitLine} />
      <Form.Item noStyle name='appliedToShippingRates' valuePropName='checked'>
        <Checkbox className={css.checkboxBox}>
          <span className={css.checkTitle}>Charge tax on shipping rates</span>
          <span className={css.checkDescription}>
            If this rate also applies to shipping, check this box.
          </span>
        </Checkbox>
      </Form.Item> */}
    </SectionWrapper>
  );
};

export default TaxValidCountry;
